import React, { useState, useEffect } from "react";
import Button from "../base/Button";
import * as FaIcons from "react-icons/fa";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import ReactPaginate from "react-paginate";

import CustomPhoneInput from "../Agents/InputField";
import { isValidPhoneNumber } from "react-phone-number-input";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";

function WalkInClients() {
  const [clientName, setClientName] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedAssignedTo, setSelectedAssignedTo] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [branches, setBranches] = useState([]);

  const [loading, setLoading] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editClient, setEditClient] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);

  const [walkInClients, setWalkInClients] = useState([]);
  const [skeleton, setSkeleton] = useState(false);

  const [viewClient, setViewClient] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);

  const [form, setForm] = useState({
    name: "",
    city: "",
    phone: "",
    branch: "",
    assigned_to: "",
    reference: "",
    comments: "",
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
  });

  const openAddModal = () => {
    setEditClient(null);
    setForm({
      name: "",
      city: "",
      phone: "",
      branch: "",
      assigned_to: "",
      reference: "",
      comments: "",
    });
    setFormErrors({ name: "" });
    setOpenModal(true);
  };

  const openEditModal = (client) => {
    setEditClient(client);
    setForm({
      name: client.name || "",
      city: client.city || "",
      phone: client.phone || "",
      branch: client.branch || "",
      assigned_to: client.assigned_to?.toString() || "",
      reference: client.reference || "",
      comments: client.comments || "",
    });
    setFormErrors({ name: "" });
    setOpenModal(true);
  };

  const [filterKey, setFilterKey] = useState(0);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });
  // get all users
  const getAllUsers = async () => {
    try {
      const response = await apiUrl.get("fetchAllActiveUsers");
      if (response?.data?.data) {
        const allUsers = response?.data?.data;
        setAllUsers(allUsers);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  //  fetch branches
  const fetchBranches = async () => {
    try {
      const resp = await apiUrl.get("get_branches_type");
      if (resp) {
        const { branches: branchesData } = resp?.data?.data;
        setBranches(branchesData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllUsers();
    fetchBranches();
  }, []);

  useEffect(() => {
    getWalkInClients();
  }, [filterKey, pagination.currentPage, pagination.perPage]);

  // fetch data for walk in clients with filters
  const getWalkInClients = async () => {
    try {
      setSkeleton(true);
      const params = {
        name: clientName.trim(),
        phone: phone.trim(),
        branch: selectedBranch,
        assigned_to: selectedAssignedTo,
        start_date: startDate,
        end_date: endDate,
        page: pagination.currentPage,
        per_page: pagination.perPage,
      };
      const response = await apiUrl.get("/walkin-clients", { params });
      if (response?.data) {
        const { data, pagination } = response.data;
        setWalkInClients(data);
        setPagination((prev) => ({
          ...prev,
          total: pagination.total,
          lastPage: pagination.last_page,
        }));
      }
    } catch (error) {
      console.error("Error fetching walk-in clients:", error);
    } finally {
      setSkeleton(false);
    }
  };
  // handle pagination
  const handlePerPageChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  const validateForm = () => {
    let valid = true;
    const errors = { name: "", phone: "" };

    if (!form.name.trim()) {
      errors.name = "Client name is required";
      valid = false;
    }

    setFormErrors(errors);
    return valid;
  };

  const saveClient = async () => {
    if (!validateForm()) return;

    setLoadingButton(true);
    try {
      const payload = {
        name: form.name.trim(),
        city: form.city.trim(),
        phone: form.phone.trim(),
        branch: form.branch,
        assigned_to: form.assigned_to ? parseInt(form.assigned_to) : null,
        reference: form.reference.trim(),
        comments: form.comments.trim(),
      };

      const response = await apiUrl.post("/walkin-clients", payload);
      if (response?.data?.status) {
        Swal.fire({
          title: response.data.message,
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
        setOpenModal(false);
        getWalkInClients();
      }
    } catch (error) {
      console.error("Failed to save client:", error);
    } finally {
      setLoadingButton(false);
    }
  };

  const updateClient = async () => {
    if (!validateForm()) return;
    if (!editClient?.id) return;

    setLoadingButton(true);
    try {
      const payload = {
        name: form.name.trim(),
        city: form.city.trim(),
        phone: form.phone.trim(),
        branch: form.branch,
        assigned_to: form.assigned_to ? parseInt(form.assigned_to) : null,
        reference: form.reference.trim(),
        comments: form.comments.trim(),
      };

      const response = await apiUrl.put(
        `walkin-clients/${editClient.id}`,
        payload,
      );
      if (response?.data?.status) {
        Swal.fire({
          title: response.data.message,
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
        setOpenModal(false);
        getWalkInClients();
      }
    } catch (error) {
      console.error("Failed to update client:", error);
    } finally {
      setLoadingButton(false);
    }
  };

  return (
    <div className="card px-4 py-3 bg-white">
      {/* header */}
      <div className="flex justify-between items-center py-2 rounded-md">
        <h1 className="h4 font-semibold">Walk In Clients</h1>
        <div>
          <Button
            text="Add Client"
            variant="primary"
            size="lg"
            onClick={openAddModal}
          ></Button>
        </div>
      </div>

      {/* filters */}
      <div className="mb-6 bg-gray-50 rounded-lg border border-gray-200 p-4">
        <div className="flex flex-wrap gap-4 mb-3">
          {/* client name */}
          <div className="flex-1 ">
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Client Name
            </label>
            <input
              type="text"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              placeholder="Search client..."
              className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white"
            />
          </div>

          {/* phone */}
          <div className="flex-1 ">
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Phone
            </label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Search phone..."
              className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white"
            />
          </div>

          {/* Branch */}
          <div className="flex-1 ">
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Branch
            </label>
            <select
              value={selectedBranch}
              onChange={(e) => setSelectedBranch(e.target.value)}
              className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white"
            >
              <option value="">Select Branch</option>
              {branches &&
                branches?.map((branch, idx) => (
                  <option key={idx} value={branch}>
                    {branch.charAt(0).toUpperCase() + branch.slice(1)}
                  </option>
                ))}
            </select>
          </div>

          {/* assigned to */}
          <div className="flex-1 min-w-[180px]">
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Assigned To
            </label>
            <select
              value={selectedAssignedTo}
              onChange={(e) => setSelectedAssignedTo(e.target.value)}
              className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white"
            >
              <option value="">Select User</option>
              {allUsers?.map((user) => (
                <option key={user.id} value={user.id.toString()}>
                  {user?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex-1 min-w-[180px]">
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Start Date
            </label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              placeholder="start Date..."
              className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white"
            />
          </div>

          <div className="flex-1 min-w-[180px]">
            <label className="block text-sm font-medium text-gray-600 mb-1">
              End Date
            </label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              placeholder="Search phone..."
              className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white"
            />
          </div>
        </div>
        <div className="flex items-center justify-end gap-2">
          <div>
            <Button
              text="Clear All"
              variant="outline"
              size="sm"
              onClick={() => {
                setFilterKey((prev) => prev + 1);
                setClientName("");
                setPhone("");
                setSelectedBranch("");
                setSelectedAssignedTo("");
                setStartDate("");
                setEndDate("");
              }}
            />
          </div>
          <div>
            <Button
              text="Apply Filter"
              variant="primary"
              size="sm"
              onClick={() => {
                setPagination((prev) => ({ ...prev, currentPage: 1 }));
                setFilterKey((prev) => prev + 1);
              }}
            />
          </div>
        </div>
      </div>

      {/* table */}
      <table className="table table-bordered bg-white">
        <thead>
          <tr>
            <th className="text-center">Client Name</th>
            <th className="text-center">City</th>
            <th className="text-center">Phone</th>
            <th className="text-center">Branch</th>
            <th className="text-center">Assigned To</th>
            <th className="text-center">Created At</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {skeleton ? (
            <>
              {[...Array(5)].map((_, i) => (
                <tr key={i}>
                  <td className="py-3 text-center">
                    <span className="block h-5 w-24 bg-gray-300 rounded-md animate-pulse"></span>
                  </td>
                  <td className="py-3 text-center">
                    <span className="block h-5 w-20 bg-gray-300 rounded-md animate-pulse"></span>
                  </td>
                  <td className="py-3 text-center">
                    <span className="block h-5 w-28 bg-gray-300 rounded-md animate-pulse"></span>
                  </td>
                  <td className="py-3 text-center">
                    <span className="block h-5 w-20 bg-gray-300 rounded-md animate-pulse"></span>
                  </td>
                  <td className="py-3 text-center">
                    <span className="block h-5 w-24 bg-gray-300 rounded-md animate-pulse"></span>
                  </td>
                  <td className="py-3 text-center">
                    <span className="block h-5 w-28 bg-gray-300 rounded-md animate-pulse"></span>
                  </td>
                  <td className="py-3 text-center">
                    <div className="flex justify-center gap-2">
                      <span className="block h-6 w-6 bg-gray-300 rounded-full animate-pulse"></span>
                      <span className="block h-6 w-6 bg-gray-300 rounded-full animate-pulse"></span>
                    </div>
                  </td>
                </tr>
              ))}
            </>
          ) : walkInClients?.length === 0 ? (
            <tr>
              <td colSpan={7} className="text-center py-6 text-gray-500">
                No walk-in clients found.
              </td>
            </tr>
          ) : (
            walkInClients?.map((client) => (
              <tr key={client?.id}>
                <td className="align-middle px-4 py-3 text-sm text-gray-700">
                  {client?.name || "—"}
                </td>

                <td className="align-middle px-4 py-3 text-sm text-gray-700">
                  {client?.city || "—"}
                </td>

                <td className="align-middle px-4 py-3 text-sm text-gray-700">
                  {client?.phone || "—"}
                </td>

                <td className="align-middle px-4 py-3 text-sm text-gray-700">
                  {client?.branch
                    ? client?.branch.charAt(0).toUpperCase() +
                      client?.branch.slice(1)
                    : "—"}
                </td>

                <td className="align-middle px-4 py-3 text-sm text-gray-700">
                  {client?.assigned_user?.name || "—"}
                </td>

                <td className="align-middle px-4 py-3 text-sm text-gray-700">
                  {client?.created_at
                    ? new Date(client?.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : "—"}
                </td>

                {/* Actions */}
                <td className="px-4 py-3 text-center">
                  <div className="flex justify-center gap-2">
                    {/* View */}
                    <button
                      title="View"
                      onClick={() => {
                        setViewClient(client);
                        setOpenViewModal(true);
                      }}
                      className="btn btn-sm btn-outline-primary p-2"
                    >
                      <FaIcons.FaEye size={14} />
                    </button>

                    {/* Edit */}

                    <button
                      className="btn btn-sm btn-outline-primary p-2"
                      onClick={() => openEditModal(client)}
                      title="Edit"
                    >
                      <FaIcons.FaEdit />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* pagination */}
      <div className="row align-items-center mb-5 mt-2">
        <div className="col-auto">
          <select
            value={pagination?.perPage}
            onChange={handlePerPageChange}
            className="form-select"
            style={{ minWidth: 80 }}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>
        <div className="col-auto text-muted">
          Page {pagination.currentPage} – Showing{" "}
          {Math.min(
            pagination.perPage,
            pagination.total -
              (pagination.currentPage - 1) * pagination.perPage,
          )}{" "}
          of {pagination.total} entries
        </div>
        <div className="col">
          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            pageCount={pagination.lastPage}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageChange}
            forcePage={pagination.currentPage - 1}
            containerClassName={"pagination justify-content-end mb-0"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
            disabledClassName={"disabled"}
          />
        </div>
      </div>

      {/* view modal */}
      {openViewModal && viewClient && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/50 z-40"
            onClick={() => setOpenViewModal(false)}
          />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl overflow-hidden">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b bg-gray-50">
                <h3 className="text-lg font-semibold text-gray-800">
                  Client Details
                </h3>
              </div>

              {/* Body */}
              <div className="p-6 text-sm text-gray-700 space-y-5">
                {/* Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs font-semibold text-gray-500">Name</p>
                    <p className="font-medium">{viewClient?.name || "—"}</p>
                  </div>

                  <div>
                    <p className="text-xs font-semibold text-gray-500">City</p>
                    <p className="font-medium">{viewClient?.city || "—"}</p>
                  </div>

                  <div>
                    <p className="text-xs font-semibold text-gray-500">Phone</p>
                    <p className="font-medium">{viewClient?.phone || "—"}</p>
                  </div>

                  <div>
                    <p className="text-xs font-semibold text-gray-500">
                      Branch
                    </p>
                    <p className="font-medium">
                      {viewClient?.branch
                        ? viewClient?.branch.charAt(0).toUpperCase() +
                          viewClient?.branch.slice(1)
                        : "—"}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs font-semibold text-gray-500">
                      Assigned To
                    </p>
                    <p className="font-medium">
                      {viewClient?.assigned_user?.name || "—"}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs font-semibold text-gray-500">
                      Reference
                    </p>
                    <p className="font-medium">
                      {viewClient?.reference || "—"}
                    </p>
                  </div>
                </div>

                {/* Comments */}
                <div>
                  <p className="text-xs font-semibold text-gray-500 mb-1">
                    Comments
                  </p>
                  <div
                    className="bg-gray-50 border rounded-lg p-3 leading-relaxed whitespace-pre-line
               max-h-36 overflow-y-auto"
                  >
                    {viewClient?.comments || "—"}
                  </div>
                </div>

                {/* Created At */}
                <div className="text-xs text-gray-500">
                  <strong>Created At:</strong>{" "}
                  {viewClient?.created_at
                    ? new Date(viewClient?.created_at).toLocaleString()
                    : "—"}
                </div>
              </div>

              {/* Footer */}
              <div className="flex justify-end px-6 py-4 border-t bg-gray-50">
                <button
                  onClick={() => setOpenViewModal(false)}
                  className="px-4 py-2 text-sm font-medium text-white bg-gray-700 rounded-lg hover:bg-gray-800"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* add client modal */}
      {openModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.45)",
              zIndex: 1040,
            }}
            onClick={() => setOpenModal(false)}
          />
          <div
            className="modal fade show d-block"
            tabIndex={-1}
            role="dialog"
            style={{ zIndex: 1050 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg max-w-4xl mx-auto">
              <div
                className="modal-content border-0 rounded-4 shadow"
                style={{ overflow: "hidden" }}
              >
                <div
                  className="modal-header"
                  style={{
                    background: "#f7f8fa",
                    borderBottom: "1px solid #eef2f6",
                  }}
                >
                  <div>
                    <h5 className="modal-title" style={{ fontWeight: 700 }}>
                      {editClient ? "Edit Client" : "Add Client"}
                    </h5>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setOpenModal(false)}
                  />
                </div>

                <div className="modal-body px-4 py-2">
                  <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Client Name (mandatory) */}
                      <div>
                        <label
                          htmlFor="client_name"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Client Name <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="client_name"
                          value={form.name}
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          className={`w-full text-sm py-2 px-3 border rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none ${
                            formErrors.name
                              ? "border-red-500"
                              : "border-gray-300"
                          }`}
                          placeholder="Enter full name"
                        />
                        {formErrors.name && (
                          <p className="text-red-500 text-xs mt-1">
                            {formErrors.name}
                          </p>
                        )}
                      </div>

                      {/* Phone */}
                      <CustomPhoneInput
                        value={form.phone}
                        onChange={(value) =>
                          setForm({ ...form, phone: value || "" })
                        }
                        placeholder="Enter phone number"
                        defaultCountry="PK"
                      />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* City */}
                      <div>
                        <label
                          htmlFor="city"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          City
                        </label>
                        <input
                          type="text"
                          id="city"
                          value={form.city}
                          onChange={(e) =>
                            setForm({ ...form, city: e.target.value })
                          }
                          className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                          placeholder="e.g., Lahore"
                        />
                      </div>

                      {/* Branch */}
                      <div>
                        <label
                          htmlFor="branch"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Branch
                        </label>
                        <select
                          id="branch"
                          value={form.branch}
                          onChange={(e) =>
                            setForm({ ...form, branch: e.target.value })
                          }
                          className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        >
                          <option disabled value="">
                            Select Branch
                          </option>
                          {branches.map((branch, idx) => (
                            <option key={idx} value={branch}>
                              {branch.charAt(0).toUpperCase() + branch.slice(1)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Assigned To */}
                      <div>
                        <label
                          htmlFor="assigned_to"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Assigned To
                        </label>
                        <select
                          id="assigned_to"
                          value={form.assigned_to}
                          onChange={(e) =>
                            setForm({ ...form, assigned_to: e.target.value })
                          }
                          className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        >
                          <option disabled value="">
                            Select User
                          </option>
                          {allUsers.map((user) => (
                            <option key={user.id} value={user.id.toString()}>
                              {user.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Reference */}
                      <div>
                        <label
                          htmlFor="reference"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Reference
                        </label>
                        <input
                          type="text"
                          id="reference"
                          value={form.reference}
                          onChange={(e) =>
                            setForm({ ...form, reference: e.target.value })
                          }
                          className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                          placeholder="How did they hear about us?"
                        />
                      </div>
                    </div>

                    <div>
                      <label
                        htmlFor="comments"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Comments
                      </label>
                      <textarea
                        id="comments"
                        value={form.comments}
                        onChange={(e) =>
                          setForm({ ...form, comments: e.target.value })
                        }
                        rows={5}
                        className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                        placeholder="Additional notes..."
                      />
                    </div>
                  </div>
                </div>

                {/* Footer actions */}
                <div
                  className="modal-footer"
                  style={{
                    background: "#f7f8fa",
                    borderTop: "1px solid #eef2f6",
                  }}
                >
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setOpenModal(false)}
                  >
                    Close
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={editClient ? updateClient : saveClient}
                    disabled={loadingButton}
                  >
                    {loadingButton ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        {editClient ? "Updating" : "Saving"}
                      </>
                    ) : (
                      <>{editClient ? "Update" : "Save"}</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default WalkInClients;
